/**
 * The one figure every sanctions sensitivity slider starts from.
 *
 * Marcel's standard (ClickUp 1248h53bmkd, October 2026): the sanctions screening in the
 * partner mask starts at 80, so nobody sets it each time. The partner KYC tab, the owner
 * (UBO) sliders and the ad-hoc risk check box all read this; the number is never written in
 * a screen itself. The server keeps the same figure in backend/crm/screening_defaults.py.
 */
export const DEFAULT_SCREENING_SENSITIVITY = 80;
